import { Buffer } from 'buffer';
(window as any).Buffer = Buffer;
(window as any).global = window;
(window as any).process = { env: {} };

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CommonModule ,registerLocaleData} from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { TokenInterceptor } from './app/core/interceptor/token.interceptor';
import { importProvidersFrom,LOCALE_ID } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ToastrModule } from 'ngx-toastr';
import localeEsCL from '@angular/common/locales/es-CL';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from '@angular/material/core';
import {
  MondayFirstDateAdapter,
  CL_DATE_FORMATS,
} from './app/shared/adapters/monday-first-date-adapter';
import { KeycloakService } from './app/services';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';

const keycloakService = new KeycloakService();
registerLocaleData(localeEsCL);

keycloakService.init().then(() => {
  bootstrapApplication(AppComponent, {
    providers: [
      provideHttpClient(withInterceptorsFromDi()),
      {
        provide: HTTP_INTERCEPTORS,
        useClass: TokenInterceptor,
        multi: true,
      },
      provideRouter(routes),
      provideAnimations(),
      providePrimeNG({
      theme: {
        preset: Lara
      }
    }),
      { provide: DateAdapter, useClass: MondayFirstDateAdapter },
      { provide: MAT_DATE_LOCALE, useValue: 'es-CL' },
      { provide: MAT_DATE_FORMATS, useValue: CL_DATE_FORMATS },
      { provide: KeycloakService, useValue: keycloakService },
       { provide: LOCALE_ID, useValue: 'es-CL' },
      importProvidersFrom(
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: environment.SW,
        }),
        ToastrModule.forRoot({
          timeOut: 3000,
          positionClass: 'toast-top-right',
          preventDuplicates: true,
          closeButton: true,
          progressBar: false,
          newestOnTop: true,
        }),
      ),
    ],
  }).catch((err) => console.error(err));
});
